function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m511.914062 256c0-141.386719-114.59375-256-255.957031-256-141.359375 0-255.957031 114.613281-255.957031 256s114.597656 256 255.957031 256c141.363281 0 255.957031-114.613281 255.957031-256zm0 0",
  fill: "#66d15f"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m406.894531 49.25c38.292969 44.746094 61.429688 102.847656 61.429688 166.363281 0 141.386719-114.59375 256-255.957031 256-56.449219 0-108.617188-18.289062-150.9375-49.25 46.945312 54.859375 116.671874 89.636719 194.527343 89.636719 141.363281 0 255.957031-114.613281 255.957031-256 0-84.929688-41.359374-160.179688-105.019531-206.75zm0 0",
  fill: "#53bc77"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m300.410156 151.886719h-88.90625c-55.894531 0-101.210937 45.320312-101.210937 101.226562 0 41.835938 25.375 77.738281 61.566406 93.164063 5.558594 2.371094 9.191406 7.789062 9.191406 13.832031v26.03125c0 8.40625 10.542969 12.171875 15.867188 5.667969l26.175781-31.964844c2.851562-3.480469 7.113281-5.5 11.613281-5.5h65.703125c55.898438 0 101.210938-45.320312 101.210938-101.230469 0-55.90625-45.3125-101.226562-101.210938-101.226562zm0 0",
  fill: "#d4ffdf"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m356.3125 168.722656c10.636719 16.023438 16.835938 35.242188 16.835938 55.914063 0 55.90625-45.3125 101.226562-101.210938 101.226562h-65.707031c-4.5 0-8.761719 2.019531-11.613281 5.5l-16.390626 20.019531c1.792969 2.492188 2.824219 5.519532 2.824219 8.726563v26.03125c0 8.40625 10.539063 12.171875 15.863281 5.667969l26.179688-31.964844c2.847656-3.480469 7.113281-5.5 11.613281-5.5h65.703125c55.898438 0 101.210938-45.320312 101.210938-101.230469 0-35.234375-18.003906-66.257812-45.308594-84.390625zm0 0",
  fill: "#b1ffc5"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  fill: "#66d15f"
}, /*#__PURE__*/React.createElement("path", {
  d: "m212.367188 251.746094c0 8.578125-6.953126 15.53125-15.53125 15.53125-8.578126 0-15.53125-6.953125-15.53125-15.53125 0-8.574219 6.953124-15.527344 15.53125-15.527344 8.578124 0 15.53125 6.953125 15.53125 15.527344zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m271.488281 251.746094c0 8.578125-6.953125 15.53125-15.53125 15.53125s-15.53125-6.953125-15.53125-15.53125c0-8.574219 6.953125-15.527344 15.53125-15.527344s15.53125 6.953125 15.53125 15.527344zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m330.613281 251.746094c0 8.578125-6.953125 15.53125-15.53125 15.53125s-15.53125-6.953125-15.53125-15.53125c0-8.574219 6.953125-15.527344 15.53125-15.527344s15.53125 6.953125 15.53125 15.527344zm0 0"
}));

var SvgChat = function SvgChat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat.7c2693c7.svg";
export { ForwardRef as ReactComponent };